import React, { Component, createRef } from 'react';
import Chat from './Chat';
import ChatTab from './ChatTab';
import { _Chat } from './models';
import './styles.scss';
import Notification from '../CommonComponents/Notification';
import KnowledgePanel from './KnowledgePanel';
import { ChatbotChannels, ALL_ACTIONS } from '../constants';
import noChatSelectImg from '../assets/icons/no-chat.svg';
import { api } from '../utils';
import EndedChats from './EndedChats';
var newTitle = '';
type Props = {
	toasterNotifier: Function;
	fileUploadStatus: {
		[key: string]: { file: { name: string; status: number } };
	};
	updateFileUploadStatus: Function;
	closeFileUploadStatus: Function;
	redirectionToLoginPage: Function;
	showScreen: string;
	tenantId: number;
	// MakeAgentAvailability:Function;
	// callAvailabilty:boolean;
	// chatChangeAvailable:Function;
	// available:boolean;
	// chatMarking:boolean;
	// showTitleNotification:Function;
	// setNotificationInterval:Function;
	// clearNotificationInterval:Function;
	// showNotification:Function;
};
type State = {
	chats: _Chat[];
	notificationText: string;
	isShowLoader: boolean;
	showNotification: boolean;
	selectedChatIndex: number;
	tabRedirection: number;
	chatmessages: any;
	chatRedirection: string;
	tabClicked: number;
	isEndedChatsSelected: boolean;
	isBotChatsSelected: boolean;
	userDetails: {
		userName: string;
		userEmail: string;
		userContact: number;
		userSource: string;
		deviceInfo: string;
		sessionId: string;
		feedbackComment: string;
		time: string;
	};
	showFileUploadIcon: boolean;
	newTitle: string;
	showingData: string;
	showEndedChats: any;
	isUserDetailsLoading: boolean;
	noChatsSelected: boolean;
	ischatTab: number;
	allbotChats: any;
	botsChatsPage: number;
	botChatsCount: number;
	// shownotify: any;
};

export default class ChatPage extends Component<Props, State> {
	interval: any;

	chatTabRef = createRef<ChatTab>();
	constructor(props: Props) {
		super(props);
		this.state = this.setInitialState();
		this.addChats = this.addChats.bind(this);
		this.onChatSelection = this.onChatSelection.bind(this);
		this.redirectTab = this.redirectTab.bind(this);
		this.chatMessages = this.chatMessages.bind(this);
		this.chatRedirection = this.chatRedirection.bind(this);
		this.chatCoversationHistory = this.chatCoversationHistory.bind(this);
		this.setIsEndedChatsSelected = this.setIsEndedChatsSelected.bind(this);
		this.setIsBotChatsSelected = this.setIsBotChatsSelected.bind(this);
		this.getUserDetails = this.getUserDetails.bind(this);
		this.getGroupingFormatDate = this.getGroupingFormatDate.bind(this);
		this.showTitleNotification = this.showTitleNotification.bind(this);
		this.setNotificationInterval = this.setNotificationInterval.bind(this);
		this.clearNotificationInterval = this.clearNotificationInterval.bind(this);
		this.showEndedChatData = this.showEndedChatData.bind(this);
		this.getUserDetailsLoading = this.getUserDetailsLoading.bind(this);
		this.showUserLoader = this.showUserLoader.bind(this);
		this.removeData = this.removeData.bind(this);
		this.showChats = this.showChats.bind(this);
		this.setchatTab = this.setchatTab.bind(this);
		this.getAllBotChats = this.getAllBotChats.bind(this);
		this.setbotsChatsPage = this.setbotsChatsPage.bind(this);
	}

	setInitialState(): State {
		return {
			chats: [],
			allbotChats: [],
			notificationText: '',
			selectedChatIndex: -1,
			botsChatsPage: 1,
			// selectedChatIndex: 0,
			showNotification: false,
			tabRedirection: 0,
			chatmessages: [],
			chatRedirection: '',
			tabClicked: -1,
			isEndedChatsSelected: false,
			isBotChatsSelected: false,
			userDetails: {
				userName: '',
				userEmail: '',
				userContact: 0,
				userSource: '',
				deviceInfo: '',
				feedbackComment: '',
				time: '',
				sessionId: '',
			},
			showFileUploadIcon: true,
			newTitle: '',
			showingData: '',
			showEndedChats: {},
			isUserDetailsLoading: false,
			isShowLoader: true,
			noChatsSelected: true,
			ischatTab: 0,
			botChatsCount: 0,
			// shownotify: false,
		};
	}

	addChats(chats: _Chat[]) {
		this.setState({
			chats,
		});
	}

	showEndedChatData(val: string) {
		this.setState({
			showingData: val,
		});
	}
	onChatSelection(index: number) {
		this.setState({
			selectedChatIndex: index,
			// shownotify: notify,
		});
	}
	getUserDetailsLoading(bool: boolean) {
		this.setState({
			isUserDetailsLoading: bool,
		});
	}
	toggleNotification(bool: boolean) {
		this.setState({
			showNotification: bool,
		});
	}
	chatCoversationHistory(tabClicked: number) {
		this.setState({
			tabClicked: this.state.tabClicked + 1,
		});
	}
	notify(text: string) {
		this.setState({
			notificationText: text,
		});
	}
	redirectTab(bool: number) {
		this.setState({
			tabRedirection: bool,
		});
	}

	showChats(val = false) {
		if (this.state.noChatsSelected || val == true) {
			this.setState({
				noChatsSelected: val,
			});
		}
	}

	componentDidUpdate() {
		newTitle = '';
	}

	componentWillUnmount() {
		// clearInterval(this.interval)
		this.clearNotificationInterval();
		document.title = 'Hybrid Dashboard';
	}

	setNotificationInterval(fn: string, time: number) {
		var timesRun = 0;
		this.interval = setInterval(() => {
			timesRun += 1;
			if (timesRun === 6) {
				// console.log('title stopped');
				this.clearNotificationInterval();
				document.title = 'Hybrid Dashboard';
				// return;
			} else {
				if (document.title === 'Hybrid Dashboard') {
					this.showTitleNotification(fn);
				} else {
					document.title = 'Hybrid Dashboard';
				}
			}
		}, time);
	}

	clearNotificationInterval() {
		clearInterval(this.interval);
	}

	showTitleNotification(sender: string) {
		newTitle = sender + ' says...';
		document.title = 'Hybrid Dashboard';
		document.title = newTitle;
	}
	removeData(end: boolean) {
		this.setState({
			showEndedChats: end,
		});
	}
	chatMessages(val: any) {
		this.setState({
			chatmessages: val,
		});
	}
	chatRedirection(val: string) {
		this.setState({
			chatRedirection: val,
		});
	}

	getGroupingFormatDate = (date: any, val: string) => {
		var newDate, todayDate, yesterdayDate, finalDate;
		if (val === 'EndedChats') {
			newDate = date;
		} else {
			newDate = date.split(' ')[0];
		}

		var today = new Date();
		var currentDate = today.getDate();
		var currentMonth = today.getMonth();
		//  console.log(currentMonth)
		if (currentMonth >= 9) {
			if (currentDate >= 9) {
				todayDate =
					today.getFullYear() + '-' + currentMonth + '-' + currentDate;
				yesterdayDate =
					today.getFullYear() + '-' + currentMonth + '-' + (currentDate - 1);
			} else {
				todayDate =
					today.getFullYear() +
					'-' +
					(currentMonth + 1) +
					'-' +
					'0' +
					currentDate;
				yesterdayDate =
					today.getFullYear() +
					'-' +
					(currentMonth + 1) +
					'-' +
					'0' +
					(currentDate - 1);
				// console.log(todayDate)
			}
		} else {
			if (currentDate > 9) {
				todayDate =
					today.getFullYear() + '-0' + (currentMonth + 1) + '-' + currentDate;
				yesterdayDate =
					today.getFullYear() +
					'-0' +
					(currentMonth + 1) +
					'-' +
					(currentDate - 1);
			} else {
				todayDate =
					today.getFullYear() + '-0' + (currentMonth + 1) + '-0' + currentDate;
				yesterdayDate =
					today.getFullYear() +
					'-0' +
					(currentMonth + 1) +
					'-0' +
					(currentDate - 1);
			}
		}
		// var today=new Date(),todayDate,yesterdayDate,finalDate;
		// var currentMonth=today.getMonth()
		// if(currentMonth>=9){
		//  todayDate=today.getFullYear()+'-'+currentMonth+'-'+today.getDate();
		//  yesterdayDate=today.getFullYear()+'-'+currentMonth+'-'+(today.getDate()-1)
		// }
		// else{
		//   todayDate=today.getFullYear()+'-0'+(currentMonth+1)+'-'+today.getDate();
		//   yesterdayDate=today.getFullYear()+'-0'+(currentMonth+1)+'-'+(today.getDate()-1)
		// }

		if (newDate == todayDate && val === 'EndedChats') {
			finalDate = 'Today';
		} else if (newDate == yesterdayDate && val === 'EndedChats') {
			finalDate = 'Yesterday';
		} else {
			const wholeDate = newDate.split('-');
			var mlist = [
				'Jan',
				'Feb',
				'Mar',
				'April',
				'May',
				'June',
				'July',
				'Aug',
				'Sep',
				'Oct',
				'Nov',
				'Dec',
			];
			// if(wholeDate[1]<9){
			var month = wholeDate[1];
			// }
			// else{
			//   var month=wholeDate[1][1]
			// }
			if (val === 'EndedChats') {
				finalDate = wholeDate[2] + ' ' + mlist[month - 1] + ', ' + wholeDate[0];
			} else {
				finalDate = mlist[month - 1] + ' ' + wholeDate[2] + ', ' + wholeDate[0];
			}
		}
		return finalDate;
	};
	getUserDetails(
		username: string,
		useremail: string,
		usercontact: number,
		userSource: string,
		deviceInfo: string,
		sessionId: string,
		feedbackComment: string,
		time: string
	) {
		this.setState(
			{
				userDetails: {
					userName: username,
					userEmail: useremail,
					userContact: usercontact,
					userSource: userSource,
					deviceInfo: deviceInfo,
					sessionId: sessionId,
					feedbackComment: feedbackComment,
					time: time,
				},
			},
			() => {
				// console.log(time)
				// this.getGroupingFormatDate(this.state.userDetails.time,'')
			}
		);
	}
	get selectedChat(): _Chat {
		var a = sessionStorage.getItem('agentId') || '';
		let LoggedinAgentIdArray: any = [];
		LoggedinAgentIdArray.push(parseInt(a));
		// console.log(this.chatTabRef.current)
		if (this.chatTabRef.current) {
			// debugger;
			const tabIndex = this.chatTabRef.current.state.selectedChatTab;
			const chats = this.state.chats.filter((chat) => {
				switch (tabIndex) {
					case 0:
						return (
							chat.tabName === 'My Queues' &&
							!chat.botConv &&
							chat.mappedAgentIds &&
							chat.mappedAgentIds.some(
								(r) => LoggedinAgentIdArray.indexOf(r) >= 0
							)
						);
					case 1:
						return (
							chat.tabName === 'My Chats' &&
							chat.mappedAgentIds &&
							chat.mappedAgentIds.some(
								(r) => LoggedinAgentIdArray.indexOf(r) >= 0
							)
						);
					case 2:
						return chat.botConv;
					default:
						return chat;
				}
			});
			// console.log(chats.length);
			if (chats.length && this.state.selectedChatIndex !== -1) {
				const chat = chats[this.state.selectedChatIndex];
				if (
					chat &&
					this.state.userDetails.userName !== chat.customerName &&
					!this.state.isEndedChatsSelected
				) {
					this.getUserDetails(
						chat.customerName,
						chat.emailId,
						parseInt(chat.phoneNumber),
						chat.channel,
						chat.deviceInfo,
						chat.sessionID,
						'',
						''
					);
				}
				return chat;
			}
		}
		return {
			name: '',
			type: '',
			title: '',
			pending: 0,
			botName: '',
			botConv: '',
			timeDiff: '',
			sessionID: '',
			ipaddress: '',
			transfer: false,
			botIconURL: '',
			s_id: '',
			collectStatus: '',
			isAutoassignedCalled: '',
			tabName: '',
			queueId: 0,
			botId: '',
			customerName: '',
			mappedAgentIds: [],
			botListLength: 0,
			isTransferOrRelease: false,
			lastMsg: '',
			channel: '',
			deviceInfo: '',
			lang: '',
			phoneNumber: '',
			emailId: '',
			isTakeOverOptedChkFlag: false,
		};
	}

	setIsEndedChatsSelected(isEndedChatsSelected: boolean) {
		this.setState({
			isEndedChatsSelected,
		});
	}
	setchatTab(tab: number) {
		this.setState({
			ischatTab: tab,
		});
	}
	getAllBotChats(page: number, appendOldChats: boolean) {
		const agentId = sessionStorage.getItem('agentId');

		if (agentId) {
			// const loggedInAgentId = parseInt(agentId);
			this.setState(
				{
					// isOldChatsLoading: true,
				},
				() => {
					api(`getBotsChats`, 'POST', {
						tenantId: this.props.tenantId,
						agentSessionID: sessionStorage.getItem('agentActiveSession'),
						agentId: agentId,
						page: page,
						timezoneOffset: new Date().getTimezoneOffset(),
					})
						.then((response) => {
							if (response.error === 'Authentication Failed') {
								this.props.redirectionToLoginPage();
							} else {
								if (response.ResType === 'Success') {
									if (response.ResData.redirectToLogin === true) {
										this.props.redirectionToLoginPage();
									} else {
										this.setState((prevState: State) => {
											return {
												allbotChats: appendOldChats
													? [
															...prevState.allbotChats,
															...response.ResData.ResArray,
													  ]
													: response.ResData.ResArray,
												// isOldChatsLoading: false,
												botsChatsPage: page + 1,
												botChatsCount: response.ResData.ResChatCount,
												// oldChatsExhausted: Array.isArray(response) && response.length === 0,
											};
										});
									}
								}
							}
						})
						.catch((e) => {
							console.log(e);
						});
				}
			);
		}
	}
	setIsBotChatsSelected(isBotChatsSelected: boolean, pages?: number) {
		this.setState({
			isBotChatsSelected,
		});
	}
	setbotsChatsPage() {
		this.setState(
			{
				botsChatsPage: 1,
			},
			() => {
				this.getAllBotChats(this.state.botsChatsPage, false);
			}
		);
	}
	showUserLoader(val: boolean) {
		this.setState({
			isShowLoader: val,
		});
	}

	render() {
		if (sessionStorage.getItem('roleId') !== '3') {
			return (
				<div className='chatpage-wrapper'>
					<ChatTab
						redirectionToLoginPage={this.props.redirectionToLoginPage}
						ref={this.chatTabRef}
						chats={this.state.chats}
						addChats={this.addChats}
						showUserLoader={this.showUserLoader}
						notificationToaster={this.props.toasterNotifier}
						selectChat={this.onChatSelection}
						selectedChatIndex={this.state.selectedChatIndex}
						redirectionTab={this.state.tabRedirection}
						displayChatMessage={this.state.chatmessages}
						chatRedirection={this.state.chatRedirection}
						chatCoversationHistory={this.chatCoversationHistory}
						setIsEndedChatsSelected={this.setIsEndedChatsSelected}
						setIsBotChatsSelected={this.setIsBotChatsSelected}
						userDetails={this.state.userDetails}
						getGroupingFormatDate={this.getGroupingFormatDate}
						showTitleNotification={this.showTitleNotification}
						setNotificationInterval={this.setNotificationInterval}
						clearNotificationInterval={this.clearNotificationInterval}
						// available={this.props.available}
						showEndedChatData={this.showEndedChatData}
						getUserDetails={this.getUserDetails}
						showEndedChats={this.state.showEndedChats}
						showChats={this.showChats}
						noChatsSelected={this.state.noChatsSelected}
						showScreen={this.props.showScreen}
						tenantId={this.props.tenantId}
						setchatTab={this.setchatTab}
						getAllBotChats={this.getAllBotChats}
						allbotChats={this.state.allbotChats}
						botChatsCount={this.state.botChatsCount}
						botsChatsPage={this.state.botsChatsPage}
						setbotsChatsPage={this.setbotsChatsPage}
						// showNotification={this.showNotification}
					/>

					<Chat
						isTakeOverOptedChkFlag={
							this.selectedChat && this.selectedChat.isTakeOverOptedChkFlag
						}
						redirectionToLoginPage={this.props.redirectionToLoginPage}
						type={this.selectedChat && this.selectedChat.type}
						title={this.selectedChat && this.selectedChat.title}
						botConv={this.selectedChat && !!this.selectedChat.botConv}
						transfer={this.selectedChat && this.selectedChat.transfer}
						sessionID={this.selectedChat && this.selectedChat.sessionID}
						handoff_id=''
						ipaddress={this.selectedChat && this.selectedChat.ipaddress}
						deviceInfo={this.selectedChat && this.selectedChat.deviceInfo}
						time={this.selectedChat && this.selectedChat.timeDiff}
						channel={this.selectedChat && this.selectedChat.channel}
						collectStatus={this.selectedChat && this.selectedChat.collectStatus}
						isAutoassignedCalled={
							this.selectedChat && this.selectedChat.isAutoassignedCalled
						}
						tabName={this.selectedChat && this.selectedChat.tabName}
						queueId={this.selectedChat && this.selectedChat.queueId}
						lang={this.selectedChat && this.selectedChat.lang}
						phoneNumber={this.selectedChat && this.selectedChat.phoneNumber}
						emailId={this.selectedChat && this.selectedChat.emailId}
						notify={(text: string) => {
							this.toggleNotification(true);
							this.notify(text);
						}}
						redirectTab={this.redirectTab && this.redirectTab}
						getChatMessage={this.chatMessages}
						getUserDetails={this.getUserDetails}
						botIconUrl={this.selectedChat && this.selectedChat.botIconURL}
						notificationToaster={this.props.toasterNotifier}
						chatRedirection={this.chatRedirection && this.chatRedirection}
						isShowLoader={this.state.isShowLoader}
						botId={this.selectedChat && this.selectedChat.botId}
						customerName={this.selectedChat && this.selectedChat.customerName}
						mappedAgentIds={
							this.selectedChat && this.selectedChat.mappedAgentIds
						}
						botListLength={this.selectedChat && this.selectedChat.botListLength}
						tabClicked={this.state.tabClicked}
						isEndedChatsSelected={this.state.isEndedChatsSelected}
						isBotChatsSelected={this.state.isBotChatsSelected}
						showFileUploadIcon={this.state.showFileUploadIcon}
						fileUploadStatus={this.props.fileUploadStatus}
						updateFileUploadStatus={this.props.updateFileUploadStatus}
						closeFileUploadStatus={this.props.closeFileUploadStatus}
						showTitleNotification={this.showTitleNotification}
						setNotificationInterval={this.setNotificationInterval}
						clearNotificationInterval={this.clearNotificationInterval}
						showingData={this.state.showingData}
						removeData={this.removeData}
						// chatMarking={this.props.chatMarking}
						getUserDetailsLoading={this.getUserDetailsLoading}
						noChatsSelected={this.state.noChatsSelected}
						tenantId={this.props.tenantId}
						showScreen={this.props.showScreen}
						ischatTab={this.state.ischatTab}
						setIsBotChatsSelected={this.setIsBotChatsSelected}
						getAllBotChats={this.getAllBotChats}
						showChats={this.showChats}
						setbotsChatsPage={this.setbotsChatsPage}
						addChats={this.addChats}
						// shownotify={this.state.shownotify}
					/>
					<KnowledgePanel
						sessionID={this.selectedChat && this.selectedChat.sessionID}
						userDetails={this.state.userDetails}
						toasterNotifier={this.props.toasterNotifier}
						isEndedChatsSelected={this.state.isEndedChatsSelected}
						isBotChatsSelected={this.state.isBotChatsSelected}
						getGroupingFormatDate={this.getGroupingFormatDate}
						// chatChangeAvailable={this.props.chatChangeAvailable}
						isUserDetailsLoading={this.state.isUserDetailsLoading}
						noChatsSelected={this.state.noChatsSelected}
						type={this.selectedChat && this.selectedChat.type}
					/>

					<div
						className={`no-chat-select ${
							this.state.noChatsSelected !== true ? ' hidden' : ''
						}`}>
						<img src={noChatSelectImg} alt='NoSelect'></img>
					</div>

					<Notification
						show={this.state.showNotification}
						text={this.state.notificationText}
						hideNotification={() => {
							this.toggleNotification(false);
						}}
					/>
				</div>
			);
		} else {
			return <></>;
		}
	}
}
